function decodeJwtPayload(token) {
  try {
    var base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    while (base64.length % 4) base64 += '='
    return JSON.parse(atob(base64))
  } catch (e) {
    return null
  }
}

angular
  .module('app')
  .factory('authService', ['$http', '$q', 'STORAGE_KEYS', authServiceService])

function authServiceService($http, $q, STORAGE_KEYS) {
  var self = {
    _districts: [],
    _userDistricts: [],

    districts: function () {
      var deferred = $q.defer()
      if (self._districts.length === 0) {
        var url = globalConfig.api.districts.path
        var config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
            'Content-Type': 'application/json; charset=utf-8',
          },
        }
        $http.get(url, config).then(
          function (response) {
            self._districts = response.data.list
            return deferred.resolve(self._districts)
          },
          function () {
            return deferred.reject()
          }
        )
      } else {
        deferred.resolve(self._districts)
      }
      return deferred.promise
    },

    userDistricts: function () {
      var deferred = $q.defer()
      if (self._userDistricts.length === 0) {
        self.districts().then(
          function () {
            var ssoUser = JSON.parse(localStorage.getItem(STORAGE_KEYS.SSO_USER))
            if (ssoUser && ssoUser.access) {
              var accessList = []
              ssoUser.access
                .filter(function (element) {
                  return (
                    ['COMPETENCE_EDIT', 'COMPETENCE_LIST'].indexOf(element.a) >= 0
                  )
                })
                .map(function (element) {
                  return element.d
                })
                .forEach(function (element) {
                  element.forEach(function (item) {
                    if (accessList.indexOf(item) === -1) {
                      accessList.push(item)
                    }
                  })
                })
              var districtsList = accessList
                .map(function (element) {
                  return self._districts.find(function (item) {
                    return element === item.id
                  })
                })
                .filter(function (element) {
                  return !!element
                })
              self._userDistricts = districtsList
              return deferred.resolve(districtsList)
            } else {
              return deferred.reject()
            }
          },
          function () {
            return deferred.reject()
          }
        )
      } else {
        deferred.resolve(self._userDistricts)
      }
      return deferred.promise
    },

    logout: function () {
      window.location.href = '/login/logout.html'
    },

    refreshToken: function () {
      var refreshToken = localStorage.getItem(STORAGE_KEYS.COGNITO_REFRESH_TOKEN)
      var config = JSON.parse(localStorage.getItem(STORAGE_KEYS.COGNITO_CONFIG) || '{}')

      if (!refreshToken || !config.authDomain || !config.userPoolWebClientId) {
        return $q.reject('No refresh token or config available')
      }

      var domain = config.authDomain.replace(/^https?:\/\//, '')

      return $q(function (resolve, reject) {
        fetch('https://' + domain + '/oauth2/token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: config.userPoolWebClientId,
            refresh_token: refreshToken
          }).toString()
        })
          .then(function (r) { return r.json() })
          .then(function (cognitoData) {
            if (!cognitoData.access_token) throw new Error('Cognito refresh failed')
            return fetch(config.tokenExchangeUrl, {
              headers: {
                Authorization: 'Bearer ' + cognitoData.access_token,
                'X-Id-Token': cognitoData.id_token || '',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
              .then(function (r) { return r.json() })
              .then(function (backendToken) {
                if (!backendToken.access_token) throw new Error('Backend exchange failed')

                localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, backendToken.access_token)
                localStorage.setItem(STORAGE_KEYS.ID_TOKEN, backendToken.access_token)
                localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN_TYPE, 'Bearer')

                if (cognitoData.id_token) {
                  localStorage.setItem(STORAGE_KEYS.COGNITO_ID_TOKEN, cognitoData.id_token)
                }

                var expiration = new Date()
                expiration.setSeconds(expiration.getSeconds() + (cognitoData.expires_in || 3600))
                localStorage.setItem(STORAGE_KEYS.TOKEN_EXPIRES_AT, expiration.toString())

                var payload = decodeJwtPayload(backendToken.access_token)
                if (payload) {
                  localStorage.setItem(STORAGE_KEYS.SSO_USER, JSON.stringify(payload))
                }

                resolve(backendToken.access_token)
              })
          })
          .catch(function (err) {
            console.error('Token refresh failed:', err)
            localStorage.removeItem(STORAGE_KEYS.COGNITO_REFRESH_TOKEN)
            reject(err)
          })
      })
    },

    validateAccessByToken: function () {
      var accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
      var tokenExpiresAt = localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRES_AT)
      return !!(accessToken && tokenExpiresAt && new Date(tokenExpiresAt) > new Date())
    },

    sessionInfo: function () {
      var tokenExpiresAt = localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRES_AT)
      if (!tokenExpiresAt) {
        return { expired: new Date(0), minutesLeft: 0 }
      }
      var expires = new Date(tokenExpiresAt)
      return {
        expired: expires,
        get minutesLeft() {
          return Math.floor((expires.getTime() - Date.now()) / 60000)
        }
      }
    },
  }
  return self
}
